// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file case/v1/case.proto (package case.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreateCaseRequestSchema, IncidentType } from "./case_init_pb";
import { file_case_v1_case_init } from "./case_init_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../mobility/v1/common_pb";
import { file_mobility_v1_common } from "../../mobility/v1/common_pb";
import type { VehicleCategory, VehicleModel } from "../../mobility/v1/vehicle_pb";
import { file_mobility_v1_vehicle } from "../../mobility/v1/vehicle_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file case/v1/case.proto.
 */
export const file_case_v1_case: GenFile = /*@__PURE__*/
  fileDesc("ChJjYXNlL3YxL2Nhc2UucHJvdG8SB2Nhc2UudjEiOgoQTGlzdENhc2VzUmVxdWVzdBIRCglwYWdlX3NpemUYASABKAUSEwoLcGFnZV9jdXJzb3IYAiABKAkiSwoRTGlzdENhc2VzUmVzcG9uc2USHAoFY2FzZXMYASADKAsyDS5jYXNlLnYxLkNhc2USGAoQbmV4dF9wYWdlX2N1cnNvchgCIAEoCSIxChJDcmVhdGVDYXNlUmVzcG9uc2USGwoEY2FzZRgBIAEoCzINLmNhc2UudjEuQ2FzZSIhCg5HZXRDYXNlUmVxdWVzdBIPCgdjYXNlX2lkGAEgASgJIi4KD0dldENhc2VSZXNwb25zZRIbCgRjYXNlGAEgASgLMg0uY2FzZS52MS5DYXNlIu0CCgRDYXNlEg8KB2Nhc2VfaWQYASABKAkSIwoGc3RhdHVzGAIgASgOMhMuY2FzZS52MS5DYXNlU3RhdHVzEikKC2JlbmVmaWNpYXJ5GAMgASgLMhQuY2FzZS52MS5CZW5lZmljaWFyeRI4ChNpbW1vYmlsaXplZF92ZWhpY2xlGAQgASgLMhsuY2FzZS52MS5JbW1vYmlsaXplZFZlaGljbGUSEwoLbWlzc2lvbl9pZHMYBSADKAkSGAoLY29udHJhY3RfaWQYBiABKAlIAIgBARITCgtjYXNlX251bWJlchgHIAEoCRIuCgpjcmVhdGVkX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIYChBwYXNzZW5nZXJzX2NvdW50GAkgASgFEiwKDWluY2lkZW50X3R5cGUYCiABKA4yFS5jYXNlLnYxLkluY2lkZW50VHlwZUIOCgxfY29udHJhY3RfaWQieAoLQmVuZWZpY2lhcnkSEgoKZmlyc3RfbmFtZRgBIAEoCRIRCglsYXN0X25hbWUYAiABKAkSDQoFZW1haWwYAyABKAkSDQoFcGhvbmUYBCABKAkSJAoJYmlydGhkYXRlGAUgASgLMhEubW9iaWxpdHkudjEuRGF0ZSKEAQoSSW1tb2JpbGl6ZWRWZWhpY2xlEhQKDHBsYXRlX251bWJlchgCIAEoCRIoCgVtb2RlbBgBIAEoCzIZLm1vYmlsaXR5LnYxLlZlaGljbGVNb2RlbBIuCghjYXRlZ29yeRgDIAEoDjIcLm1vYmlsaXR5LnYxLlZlaGljbGVDYXRlZ29yeSpyCgpDYXNlU3RhdHVzEhsKF0NBU0VfU1RBVFVTX1VOU1BFQ0lGSUVEEAASFwoTQ0FTRV9TVEFUVVNfQ1JFQVRFRBABEhYKEkNBU0VfU1RBVFVTX0FDVElWRRACEhYKEkNBU0VfU1RBVFVTX0NMT1NFRBADMtwBCgtDYXNlU2VydmljZRJHCgpDcmVhdGVDYXNlEhouY2FzZS52MS5DcmVhdGVDYXNlUmVxdWVzdBobLmNhc2UudjEuQ3JlYXRlQ2FzZVJlc3BvbnNlIgASPgoHR2V0Q2FzZRIXLmNhc2UudjEuR2V0Q2FzZVJlcXVlc3QaGC5jYXNlLnYxLkdldENhc2VSZXNwb25zZSIAEkQKCUxpc3RDYXNlcxIZLmNhc2UudjEuTGlzdENhc2VzUmVxdWVzdBoaLmNhc2UudjEuTGlzdENhc2VzUmVzcG9uc2UiAEI4WjZnaXRodWIuY29tL3RoZXRyZWVwL2E2dHIvYmFja2VuZC9nZW4vZ28vY2FzZS92MTtjYXNldjFiBnByb3RvMw", [file_case_v1_case_init, file_google_protobuf_timestamp, file_mobility_v1_common, file_mobility_v1_vehicle]);

/**
 * ListCasesRequest - request to list Cases with cursor-based pagination.
 *
 * @generated from message case.v1.ListCasesRequest
 */
export type ListCasesRequest = Message<"case.v1.ListCasesRequest"> & {
  /**
   * Maximum number of cases to return. Defaults to 20 if unset.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Opaque cursor returned by a previous ListCases call. Empty string = first page.
   *
   * @generated from field: string page_cursor = 2;
   */
  pageCursor: string;
};

/**
 * Describes the message case.v1.ListCasesRequest.
 * Use `create(ListCasesRequestSchema)` to create a new message.
 */
export const ListCasesRequestSchema: GenMessage<ListCasesRequest> = /*@__PURE__*/
  messageDesc(file_case_v1_case, 0);

/**
 * ListCasesResponse - paginated list of Cases.
 *
 * @generated from message case.v1.ListCasesResponse
 */
export type ListCasesResponse = Message<"case.v1.ListCasesResponse"> & {
  /**
   * @generated from field: repeated case.v1.Case cases = 1;
   */
  cases: Case[];

  /**
   * Opaque cursor to pass as page_cursor in the next request. Empty string = no more pages.
   *
   * @generated from field: string next_page_cursor = 2;
   */
  nextPageCursor: string;
};

/**
 * Describes the message case.v1.ListCasesResponse.
 * Use `create(ListCasesResponseSchema)` to create a new message.
 */
export const ListCasesResponseSchema: GenMessage<ListCasesResponse> = /*@__PURE__*/
  messageDesc(file_case_v1_case, 1);

/**
 * CreateCaseResponse - response containing the created Case, with its initial Mission activated.
 *
 * @generated from message case.v1.CreateCaseResponse
 */
export type CreateCaseResponse = Message<"case.v1.CreateCaseResponse"> & {
  /**
   * @generated from field: case.v1.Case case = 1;
   */
  case?: Case;
};

/**
 * Describes the message case.v1.CreateCaseResponse.
 * Use `create(CreateCaseResponseSchema)` to create a new message.
 */
export const CreateCaseResponseSchema: GenMessage<CreateCaseResponse> = /*@__PURE__*/
  messageDesc(file_case_v1_case, 2);

/**
 * GetCaseRequest - request for retrieving a Case by ID.
 *
 * @generated from message case.v1.GetCaseRequest
 */
export type GetCaseRequest = Message<"case.v1.GetCaseRequest"> & {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId: string;
};

/**
 * Describes the message case.v1.GetCaseRequest.
 * Use `create(GetCaseRequestSchema)` to create a new message.
 */
export const GetCaseRequestSchema: GenMessage<GetCaseRequest> = /*@__PURE__*/
  messageDesc(file_case_v1_case, 3);

/**
 * GetCaseResponse - response containing a Case.
 *
 * @generated from message case.v1.GetCaseResponse
 */
export type GetCaseResponse = Message<"case.v1.GetCaseResponse"> & {
  /**
   * @generated from field: case.v1.Case case = 1;
   */
  case?: Case;
};

/**
 * Describes the message case.v1.GetCaseResponse.
 * Use `create(GetCaseResponseSchema)` to create a new message.
 */
export const GetCaseResponseSchema: GenMessage<GetCaseResponse> = /*@__PURE__*/
  messageDesc(file_case_v1_case, 4);

/**
 * Case - root aggregate representing a vehicle assistance situation.
 * UI state (wizard steps, forms) is handled by view/v1 - not here.
 *
 * @generated from message case.v1.Case
 */
export type Case = Message<"case.v1.Case"> & {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * @generated from field: case.v1.CaseStatus status = 2;
   */
  status: CaseStatus;

  /**
   * @generated from field: case.v1.Beneficiary beneficiary = 3;
   */
  beneficiary?: Beneficiary;

  /**
   * @generated from field: case.v1.ImmobilizedVehicle immobilized_vehicle = 4;
   */
  immobilizedVehicle?: ImmobilizedVehicle;

  /**
   * @generated from field: repeated string mission_ids = 5;
   */
  missionIds: string[];

  /**
   * contract_id is the insurance contract under which this Case was opened.
   *
   * @generated from field: optional string contract_id = 6;
   */
  contractId?: string;

  /**
   * case_number is the human-readable identifier entered by the CAS operator, unique across Cases.
   *
   * @generated from field: string case_number = 7;
   */
  caseNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: int32 passengers_count = 9;
   */
  passengersCount: number;

  /**
   * @generated from field: case.v1.IncidentType incident_type = 10;
   */
  incidentType: IncidentType;
};

/**
 * Describes the message case.v1.Case.
 * Use `create(CaseSchema)` to create a new message.
 */
export const CaseSchema: GenMessage<Case> = /*@__PURE__*/
  messageDesc(file_case_v1_case, 5);

/**
 * Beneficiary - person being assisted.
 *
 * @generated from message case.v1.Beneficiary
 */
export type Beneficiary = Message<"case.v1.Beneficiary"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: mobility.v1.Date birthdate = 5;
   */
  birthdate?: Date;
};

/**
 * Describes the message case.v1.Beneficiary.
 * Use `create(BeneficiarySchema)` to create a new message.
 */
export const BeneficiarySchema: GenMessage<Beneficiary> = /*@__PURE__*/
  messageDesc(file_case_v1_case, 6);

/**
 * ImmobilizedVehicle - vehicle that triggered the Case.
 *
 * @generated from message case.v1.ImmobilizedVehicle
 */
export type ImmobilizedVehicle = Message<"case.v1.ImmobilizedVehicle"> & {
  /**
   * @generated from field: string plate_number = 2;
   */
  plateNumber: string;

  /**
   * @generated from field: mobility.v1.VehicleModel model = 1;
   */
  model?: VehicleModel;

  /**
   * @generated from field: mobility.v1.VehicleCategory category = 3;
   */
  category: VehicleCategory;
};

/**
 * Describes the message case.v1.ImmobilizedVehicle.
 * Use `create(ImmobilizedVehicleSchema)` to create a new message.
 */
export const ImmobilizedVehicleSchema: GenMessage<ImmobilizedVehicle> = /*@__PURE__*/
  messageDesc(file_case_v1_case, 7);

/**
 * CaseStatus - lifecycle status of a Case.
 *
 * @generated from enum case.v1.CaseStatus
 */
export enum CaseStatus {
  /**
   * @generated from enum value: CASE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CASE_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: CASE_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: CASE_STATUS_CLOSED = 3;
   */
  CLOSED = 3,
}

/**
 * Describes the enum case.v1.CaseStatus.
 */
export const CaseStatusSchema: GenEnum<CaseStatus> = /*@__PURE__*/
  enumDesc(file_case_v1_case, 0);

/**
 * CaseService - manages the Case lifecycle: creation, retrieval, and closure.
 *
 * @generated from service case.v1.CaseService
 */
export const CaseService: GenService<{
  /**
   * Creates a new Case.
   *
   * @generated from rpc case.v1.CaseService.CreateCase
   */
  createCase: {
    methodKind: "unary";
    input: typeof CreateCaseRequestSchema;
    output: typeof CreateCaseResponseSchema;
  },
  /**
   * Returns a Case by ID.
   *
   * @generated from rpc case.v1.CaseService.GetCase
   */
  getCase: {
    methodKind: "unary";
    input: typeof GetCaseRequestSchema;
    output: typeof GetCaseResponseSchema;
  },
  /**
   * Returns a paginated list of Cases, ordered by creation date descending.
   *
   * @generated from rpc case.v1.CaseService.ListCases
   */
  listCases: {
    methodKind: "unary";
    input: typeof ListCasesRequestSchema;
    output: typeof ListCasesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_case_v1_case, 0);

